import React from 'react';

import MuiIconButton from '@material-ui/core/IconButton';
import MuiEditAttributesIcon from '@material-ui/icons/EditAttributes';
import MuiSaveIcon from '@material-ui/icons/Save';
import MuiDeleteIcon from '@material-ui/icons/Delete';
import MuiBlockIcon from '@material-ui/icons/Block';
import MuiCircularProgress from '@material-ui/core/CircularProgress';

import { WithTooltip } from 'utils/wrappers';

const RowButtons = props => {
  const { isMutating, editing, onEditChange, onDelete, onSave, isValid, canDelete, isGroup } = props;

  if (isMutating)
    return (
      <MuiIconButton disabled={true}>
        <MuiCircularProgress size={'1rem'} />
      </MuiIconButton>
    );

  if (editing)
    return (
      <>
        <WithTooltip tooltip="Save Changes">
          <MuiIconButton onClick={onSave} disabled={!isValid}>
            <MuiSaveIcon />
          </MuiIconButton>
        </WithTooltip>
        {/* WithTooltip disables the tooltip id disabled it set, but does not allow to disable on the icon.
        A tooltip and disabled icon is needed here */}
        <span data-tooltip={canDelete ? 'Delete Payee' : 'Payee Has splits'} data-position="bottom">
          <MuiIconButton disabled={!canDelete} onClick={onDelete}>
            <MuiDeleteIcon />
          </MuiIconButton>
        </span>
        <WithTooltip tooltip="Cancel">
          <MuiIconButton onClick={() => onEditChange(false)}>
            <MuiBlockIcon />
          </MuiIconButton>
        </WithTooltip>
      </>
    );

  {
    /* tooltip runs off the screen, but without a style guide how to correct it is unknown*/
  }
  if (isGroup)
    return (
      <WithTooltip tooltip="Cannot edit group payee">
        <MuiBlockIcon />
      </WithTooltip>
    );

  return (
    <WithTooltip tooltip="Reveal Row Actions" key="edit">
      <MuiIconButton onClick={() => onEditChange(true)}>
        <MuiEditAttributesIcon />
      </MuiIconButton>
    </WithTooltip>
  );
};
export default RowButtons;
